export default {
  "content": "<path d=\"M3 5c1-1.037 4-4 4-4L3 5zm0 0L1 3\" stroke=\"#ff00cb\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "8",
    "height": "6",
    "viewBox": "0 0 8 6",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};